<template>
	<view  v-if="!isLoading" @click="onHandleLogin">
				<view  class="msk"></view>
		<div  class="tips" >点击查看完整内容
		</div>
	<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
			<van-swipe-item v-for="(item, i) in houseDesc.community.imageUrls" :key="i" class="swipe-item" >
				<van-image :src="item + '?x-oss-process=style/standard'" class="image" fit="cover" />
				<div class="foot">
					<div class="speed">{{ (i + 1) }}/{{ houseDesc.community.imageUrls.length }}</div>
				</div>
			</van-swipe-item>
		</van-swipe>
		<div class="house-desc">
			<div class="house-desc-top">
				<div class="sub_title flex j-sb">
					<div class="left">
						<div class="tit flex">
							<div style="width:150rpx">{{ houseDesc.community.name }}ccc</div>
							<div class="status" :class="houseDesc.verifyState">{{ houseDesc.verifyState == 'PENDING' ? '待审核'
								:
								'已审核' }}</div>
						</div>
						<div class="span">**/**/**层</div>
					</div>
			

			
				</div>
				<div class="house-desc-other flex j-sb">
					<div class="other-item">
						<div class="value">{{ parseFloat(houseDesc.buildingArea).toFixed(2) }}平米</div>
						<div class="label">建筑面积</div>
					</div>
					<div class="other-item" v-if="houseDesc.purpose == 'SALE'">
						<div class="value">{{ parseFloat(houseDesc.sellingPrice) }}万</div>
						<div class="label">{{ parseFloat(houseDesc.sellingAveragePrice).toFixed(2) }}万/㎡</div>
					</div>
					<div class="other-item" v-else>
						<div class="value">{{ parseFloat(houseDesc.rent) }}元/月</div>
					</div>
					<div class="other-item">
						<div class="value">{{ getAttr(houseDesc.properties, 'rooms') }}室{{ getAttr(houseDesc.properties,
							'halls') }}厅{{ getAttr(houseDesc.properties, 'bathrooms') }}卫</div>
						<div class="label"> </div>
					</div>
				</div>
			</div>
			<van-row class="house-tag-list" :class="{ hide: !isShowTagList }">
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'type')">
					<span class="label">类型用途</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'type') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'decoration')">
					<span class="label">装修</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'decoration') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12">
					<span class="label">车位情况</span>
					<span class="value">{{ ensureArray(getAttr(houseDesc.properties, 'parking')).join(",") }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'tax')">
					<span class="label">税费</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'tax') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'academicStatus')">
					<span class="label">学籍情况</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'academicStatus') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24">
					<span class="label">学区</span>
					<span class="value">{{ ensureArray(houseDesc.community.schools).map(v => v.name).join(" ") }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'sellingPoint')">
					<span class="label">卖点</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'sellingPoint') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'seeHouse')">
					<span class="label">看房方式</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'seeHouse') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12">
					<span class="label">电梯情况</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'elevator') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'usableArea')">
					<span class="label">使用面积</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'usableArea') }}㎡</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'orientation')">
					<span class="label">朝向</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'orientation') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'remarks') && !route.query.clientId">
					<span class="label">备注</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'remarks') }}</span>
				</van-col>
			</van-row>
		</div>
	<!-- 	<div class="house-other">
			<div class="title">其他信息</div>
			<van-row class="house-tag-list">
				<van-col :span="24" class='col-item'>
					<div class="label">房源编码</div>
					<div class="value">{{ houseDesc.id }}</div>
				</van-col>
				<van-col :span="24" class='col-item'>
					<div class="label">录入时间</div>
					<div class="value">{{ dayjs(houseDesc.createdTime).format("YYYY/MM/DD") }}</div>
				</van-col>
			</van-row>
		</div> -->
	


	</view>
	
	<div v-if="isLoading&&houseDesc">
		<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
			<van-swipe-item v-for="(item, i) in houseDesc.community.imageUrls" :key="i" class="swipe-item" @click="openimg(i)">
				<van-image :src="item + '?x-oss-process=style/standard'" class="image" fit="cover" />
				<div class="foot">
					<!-- <div class="title">客厅</div> -->
					<div class="speed">{{ (i + 1) }}/{{ houseDesc.community.imageUrls.length }}</div>
				</div>
			</van-swipe-item>
		</van-swipe>
		<div class="house-desc">
			<div class="house-desc-top">
				<div class="sub_title flex j-sb">
					<div class="left">
						<div class="tit flex">
							<div style="width:150px">{{ houseDesc.community.name }}</div>
							<div class="status" :class="houseDesc.verifyState">{{ houseDesc.verifyState == 'PENDING' ? '待审核'
								:
								'已审核' }}</div>
						</div>
						<div class="span">{{ get_floor_type(houseDesc.floor, houseDesc.totalFloors) }}
	</div>
					</div>
			

				<div @click='towebwebresources'  v-if="houseDesc.property" style="border-color:green;" class="right flex">
				
					    <span style="color:green;">查看认证详情</span>
					</div>
				</div>
				<div class="house-desc-other flex j-sb">
					<div class="other-item">
						<div class="value">{{ parseFloat(houseDesc.buildingArea).toFixed(2) }}平米</div>
						<div class="label">建筑面积</div>
					</div>
					<div class="other-item" v-if="houseDesc.purpose == 'SALE'">
						<div class="value">{{ parseFloat(houseDesc.sellingPrice) }}万</div>
						<div class="label">{{ parseFloat(houseDesc.sellingAveragePrice).toFixed(2) }}万/㎡</div>
					</div>
					<div class="other-item" v-else>
						<div class="value">{{ parseFloat(houseDesc.rent) }}元/月</div>
					</div>
					<div class="other-item">
						<div class="value">{{ getAttr(houseDesc.properties, 'rooms') }}室{{ getAttr(houseDesc.properties,
							'halls') }}厅{{ getAttr(houseDesc.properties, 'bathrooms') }}卫</div>
						<div class="label"> </div>
					</div>
				</div>
			</div>
			<van-row class="house-tag-list" :class="{ hide: !isShowTagList }">
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'type')">
					<span class="label">类型用途</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'type') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'decoration')">
					<span class="label">装修</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'decoration') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12">
					<span class="label">车位情况</span>
					<span class="value">{{ ensureArray(getAttr(houseDesc.properties, 'parking')).join(",") }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'tax')">
					<span class="label">税费</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'tax') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'academicStatus')">
					<span class="label">学籍情况</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'academicStatus') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24">
					<span class="label">学区</span>
					<span class="value">{{ ensureArray(houseDesc.community.schools).map(v => v.name).join(" ") }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'sellingPoint')">
					<span class="label">卖点</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'sellingPoint') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'seeHouse')">
					<span class="label">看房方式</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'seeHouse') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12">
					<span class="label">电梯情况</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'elevator') }}</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'usableArea')">
					<span class="label">使用面积</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'usableArea') }}㎡</span>
				</van-col>
				<van-col class='col-item flex' span="12" v-if="getAttr(houseDesc.properties, 'orientation')">
					<span class="label">朝向</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'orientation') }}</span>
				</van-col>
				<van-col class='col-item flex' span="24" v-if="getAttr(houseDesc.properties, 'remarks') && !route.query.clientId">
					<span class="label">备注</span>
					<span class="value">{{ getAttr(houseDesc.properties, 'remarks') }}</span>
				</van-col>
			</van-row>
		</div>
	<!-- 	<div class="house-other">
			<div class="title">其他信息</div>
			<van-row class="house-tag-list">
				<van-col :span="24" class='col-item'>
					<div class="label">房源编码</div>
					<div class="value">{{ houseDesc.id }}</div>
				</van-col>
				<van-col :span="24" class='col-item'>
					<div class="label">录入时间</div>
					<div class="value">{{ dayjs(houseDesc.createdTime).format("YYYY/MM/DD") }}</div>
				</van-col>
			</van-row>
		</div> -->
		<div class="footer">
			<van-action-bar fixed class="footer-action-bar" style="z-index:999;">
				<van-action-bar-button type="primary" text="查看更多房源" @click="onMeShop" />
				<van-action-bar-button type="success" text="联系置业顾问" @click="onMakeCall" />
			</van-action-bar>
		</div>
		<Mark v-if="mark" @onhide="mark = false"></Mark>
	</div>
</template>
<script setup>
import { getHouserDetailById,getnewHouserDetailById } from "@/api";
import { getAttr, get_floor_type, getImages, ensureArray } from "@/utils/index"
import dayjs from "dayjs"
import Mark from "./Mark.vue"
import HomeMinix from "./HomeMinix";
import router from "@/router";
import { showImagePreview } from 'vant';
let { houseDesc, mark, isShowTagList, route, isLoading, onShare, onMakeCall, setShare, onHandleLogin, runWxLogin } = HomeMinix()


if (router.currentRoute.value.query.code) {

	runWxLogin()
}

let clientId = localStorage.getItem("clientId")
if(localStorage.getItem('token')){
	getHouserDetailById(route.query.id || '7027108255750946816', clientId).then(res => {
		houseDesc.value = res.data.data;
		houseDesc.value.community.imageUrls = getImages(res.data.data)
	setTimeout(() => {
			setShare()
		}, 200)
		
	})
}else{
		
			getnewHouserDetailById(route.query.id || '7027108255750946816', clientId).then(res => {
				houseDesc.value = res.data.data;
				houseDesc.value.community.imageUrls = getImages(res.data.data)
			
				
			})
}


function towebwebresources(){
		let url =  `https://m.jhtmsf.com/#/authenticate/${houseDesc.value.property.HouseNO}?_areaCode=JH`
		window.open(url)
			
}

const onMeShop = () => {
	let clientId = localStorage.getItem("clientId")
	router.push({ path: "/list", query: { clientId: clientId } })
}
const openimg = (index) => {
	const images = ensureArray(houseDesc.value?.community?.imageUrls);
	showImagePreview({
		images: images.map((item) => item + '?x-oss-process=style/standard'),
		startPosition: index,
	});
}
</script>

<style lang="less">
.tips {
	text-align: center;
	color: red;
	font-size: 36px;
position: fixed;
left: 50%;
transform: translateX(-50%);
top:41vh;
z-index: 999;
}

.my-swipe {
	height: 440px;

	.swipe-item {
		position: relative;

		.image {
			width: 100%;
			height: 440px;
		}
	}

	.foot {
		position: absolute;
		bottom: 20px;
		right: 30px;
		left: 30px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		.title,
		.speed {
			width: max-content;
			background: rgba(0, 0, 0, 0.4);
			border-radius: 24px;
			font-size: 24px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			padding: 10px 12px;
			line-height: 1;
		}
	}
}

.house-desc {
	padding: 0 30px;
	background-color: #fff;

	.sub_title {
		position: relative;
		margin-bottom: 40px;

		.tit {
			font-size: 42px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #333333;
			margin-bottom: 16px;
			align-items: center;

			span {
				font-weight: bold;
			}
		}

		.span {
			font-size: 44px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #787878;
		}

		.status {
			border: 1px solid #FF6A19;
			border-radius: 18px;
			font-size: 30px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #FF6A19;
			padding: 8px 22px;
			line-height: 1;
			height: max-content;
			margin-left: 20px;

			&.VERIFIED {
				color: #409eff;
				border-color: #409eff;
			}
		}

		.right {
			width: 210px;
			height: 60px;
			border: 1px solid #DDDDDD;
			border-radius: 10px;
			align-items: center;
			line-height: 1;
			justify-content: center;
			color: #999999;

			span {
				font-size: 32px;
				font-family: PingFang SC;
				font-weight: 400;

			}
		}
	}

	.house-desc-other {
		.other-item {
			&:nth-child(2) .value {
				color: #FE615A;
			}

			.label {
				font-size: 32px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #787878;
			}

			.value {
				font-size: 38px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #333333;
				margin-bottom: 20px;
			}
		}
	}

	.house-desc-top {
		padding: 40px 0;
		border-bottom: 1px solid #DDDDDD;
	}
}

.house-tag-list {
	flex-wrap: wrap;
	padding: 40px 0px 0;

	&.hide {
		display: none;
	}

	.col-item {
		display: flex;
		flex-direction: row;
		margin-bottom: 30px;
		line-height: 1.5;
	}

	.label {
		width: 150px;
		height: 28px;
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #787878;
		white-space: nowrap;
	}

	.value {
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	.btn {
		width: 120px;
		height: 50px;
		border: 1px solid #3D74FF;
		border-radius: 10px;
		font-size: 30px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #3D74FF;
		text-align: center;
		line-height: 50px;
	}
}

.house-tag-handle {
	align-items: center;
	font-size: 24px;
	font-family: PingFang SC;
	font-weight: 400;
	color: #787878;
	justify-content: center;
	padding: 40px 0;
}

.house-message {
	margin-top: 20px;
	background-color: #fff;

	.search {
		padding: 30px 30px 0;

		.input {
			border: 1px solid #DDDDDD;
			border-radius: 10px;
			overflow: hidden;
			height: max-content;

			.van-cell {
				padding: 10px;
			}
		}

		.icon {
			width: 36px;
			height: 36px;
		}
	}

	.message-list {
		padding: 0 30px;
	}

	.user {
		align-items: center;

		span {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #999999;
			margin-left: 14px;
		}

		van-image {
			width: 40px;
			height: 40px;
		}
	}

	.message-item {
		position: relative;
		z-index: 1;
		border-bottom: 1px solid #DDDDDD;
		padding: 30px 0 25px;

		&:last-child {
			border: none;
		}

		.time {
			position: absolute;
			right: 0;
			top: 30px;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #999999;
		}

		img {
			width: 40px;
			height: 40px;
		}

		.message {
			font-size: 30px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #333333;
			margin-top: 20px;
		}
	}
}

.house-other {
	padding: 0 30px;
	background-color: #fff;
	margin-top: 20px;

	.title {
		font-size: 32px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #333333;
		padding-top: 40px;
	}
}

.footer {
	height: 110px;

	:deep(.footer-action-bar) {
		--van-action-bar-height: 100px;
		--van-action-bar-button-height: 88px;
		height: 100px;
	}

	:deep(.van-action-bar-button) {
		font-size: 32px;
	}
}

.msk{
	position: fixed;
	bottom: 1rpx;
	width: 100vw;
	height: 55vh;
	
	   background-color: rgba(255, 255, 255, 0.2); /* 半透明背景 */
	   backdrop-filter: blur(10px); /* 背景模糊 */
	   -webkit-backdrop-filter: blur(10px); 
	  z-index: 999999999;
	  margin-top: 45vh;
}
</style>